import UnidadeMedidaService from "@/services/UnidadeMedidaService"

export const actions = {
    cadastrarUnidadeMedida: ({commit, dispatch}) => {
        commit('setUnidadeMedida', {
            undiade: "",
            descricao: "",
            permite_fracionamento: true,
        }),
        dispatch('setModalCadastroUnidadeMedida', true)
    },
    listarUnidadeMedida: ({commit}, data) => {
        commit('setOverlay', true)
        UnidadeMedidaService.listar(data)
        .then(res => {
            commit('setOverlay', false)
            commit('setUnidadesMedidas', res.data)
        })
        .catch(e => {
            commit('setOverlay', false)
            console.log(e)
        })
    },
    visualizarUnidadeMedida: ({commit, dispatch}, data) => {
        commit('setUnidadeMedida', data)
        dispatch('setModalCadastroUnidadeMedida', true)
    },
    salvarUnidadeMedida: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        UnidadeMedidaService.salvar(data)
        .then(res => {
            commit('addUnidadeMedida', res.data)
            commit('setUnidadeMedida', res.data)
            commit('setOverlay', false)
            commit('snackbarSuccess', 'Unidade de medida cadastrada.')
            dispatch('setModalCadastroUnidadeMedida', false)
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao cadastrar.')
        })
    },
    atualizarUnidadeMedida: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        UnidadeMedidaService.atualizar(data)
        .then(res => {
            commit('setOverlay', false)
            commit("snackbarInfo", "Unidade de medida atualizada.");
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao atualizar.')
        })
    },
    excluirUnidadeMedida: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        dispatch('setModalExcluirUnidadeMedida', false)
        dispatch('setModalCadastroUnidadeMedida', false)
        UnidadeMedidaService.excluir(data.id)
        .then(res => {
            commit('removeUnidadeMedida', data)
            commit('setOverlay', false)
            commit("snackbarError", "Unidade de medida excluída.");
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)
            commit("snackbarError", "Erro ao excluir unidae de medida.");
        })
    },
    setModalCadastroUnidadeMedida: ({commit}, status) => {
        commit('setModalCadastrarUnidadeMedida', false)
        setTimeout(() => {
            commit('setModalCadastrarUnidadeMedida', status)
        }, 100);
    },
    setModalExcluirUnidadeMedida: ({commit}, status) => {
        commit('setModalExcluirUnidadeMedida', false)
        setTimeout(() => {
            commit('setModalExcluirUnidadeMedida', status)
        }, 100);
    },
}

export default {}